export const convertDateToDDMMYYYY = (dateString: string | Date): string => {
  if (!dateString) return "";
  
  let date: Date;
  if (typeof dateString === 'string') {
    date = new Date(dateString);
  } else {
    date = dateString;
  }
  
  if (isNaN(date.getTime())) {
    // If it's a string in YYYY-MM-DD format
    const [year, month, day] = dateString.toString().split("-");
    if (year && month && day) {
      const dayCorrected = day.split("T")[0];
      return `${dayCorrected}-${month}-${year}`;
    }
    return "";
  }
  
  // Format as DD-MM-YYYY
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}-${month}-${year}`;
};
